
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dispensary/[cName]",
      function () {
        return require("private-next-pages/dispensary/[cName].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dispensary/[cName]"])
      });
    }
  